module.exports = __webpack_public_path__ + "img/no-file.0a189a18.png";